import { cn } from "@utils/tw"

export const Chip = ({ className, children }: { className?: string; children?: React.ReactNode }) => {
  return (
    <div
      className={cn(
        `bg-concrete50 text-black font-medium flex px-3 py-2 type-mobile-label-label-m md:type-desktop-label-label-m`,
        className,
      )}
    >
      {children}
    </div>
  )
}
